import axios from 'axios';
import {Liferay} from "../common/services/liferay/liferay";

const axiosInstance = axios.create();

const requestFulfilled = async (request) => {
    if (Liferay.authToken) {
        request.headers["x-csrf-token"] = window.Liferay.authToken;
    }
    return request;
};

const requestRejected = (error) => {
    return Promise.reject(error);
};

const responseFulfilled = (response) => response;

const responseRejected = (error) => {
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    if (axiosInstance.isHandled) {
        return Promise.reject(error);
    } else {
        return Promise.reject(error);
    }
};

axiosInstance.interceptors.request.use(requestFulfilled, requestRejected);
axiosInstance.interceptors.response.use(responseFulfilled, responseRejected);

export default axiosInstance;
